import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    height: 50px;
    background-color: white;
    justify-content: center;
    @media screen and (max-width: 750px) {
        height: fit-content !important;
        // margin: 10px;
    }
`;
const StyledLink = styled.a`
  color: #1783b4;
  cursor: pointer;
  text-decoration: none;
`;

const footer = (props) =>{
    const t = props.translation;
    return (
        <FooterWrapper>
            <div className='footer-div'>
                <StyledLink
                    href='https://www.zebra.com/us/en/support-downloads/eula/restricted-eula.html'>
                    {t('footerText2')}
                </StyledLink>
                {t('footerText3',{str:new Date().getFullYear()})}
            </div>
        </FooterWrapper>
    );
}

export default footer;
